import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import HookList from './hook_list';

class HookSetting extends Component {
    render() {
        return (
            <div>
                <Switch>

                    <Route path="/settings/hooks" component={HookList}/>
                    {/* <Redirect from="/settings/users" to="/settings/users/list"/> */}
                    <Redirect from="*" to= "/settings/hooks"/>
                </Switch>
            </div>
        );
    }
}

export default HookSetting;
